




























































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AlpacaCard from '@/components/AlpacaCard.vue';
import WearableCard from '@/components/WearableCard.vue';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import AInfo from '@/components/AInfo.vue';
import Boost from '@/components/Boost.vue';
import SelectScarfPopup from '@/components/SelectScarfPopup.vue';
import { getAlpacaInfo } from '@/backend/requests';
import { Alpaca, Wearable } from '@/backend/type';
import { alpaUnit } from '@/utils/unit';
import { isOwnerOf, getCurBlockNumber, crack, getAlpaca } from '@/utils/web3';
import { addressFormat } from '@/utils/unit';
import { EventBus } from '@/utils/EventBus';
import { format, intervalToDuration } from 'date-fns';
import { ROUTE_ADOPT, ROUTE_ALPACA, ROUTE_BREEDING } from '@/router';
import { secPerBlock } from '@/utils/constant';
import BigNumber from 'bignumber.js';
import { isApprovedForAll, setApprovalForAll } from '@/contract/wearable';
import { wear, takeOff } from '@/contract/alpacaTailor';

@Component({
  components: {
    AlpacaCard,
    AInfo,
    AlpacaBtn,
    Boost,
    WearableCard,
    SelectScarfPopup,
  },
})
export default class AlpacaInfo extends Vue {
  @Prop({
    required: true,
  })
  public alpacaID!: number;

  public alpaca: Alpaca | null = null;
  public isOwner: boolean = false;
  public loaded: boolean = false;
  public curBlockNumber: number | null = null;
  public countDownInterval: number = 0;
  public remainingTime: number = 0;
  public countdown: number = 0;
  public costResetRemainingTime: number = 0;
  public costResetCountdown: number = 0;
  public alpaInfoFromContract: any = null;
  public isApprovedForWear: boolean = false;
  public approveLoading: boolean = false;
  public showSelectPopup: boolean = false;


  get account() {
    return this.$store.getters.getAccount;
  }

  get hasParent() {
    return this.alpaca && this.alpaca.sire;
  }

  get buttonDisabled() {
    return this.remainingTime > 0;
  }

  get isRecycled() {
    return this.alpaca && this.alpaca.recycled;
  }

  get ownerAddress() {
    if (!this.alpaca) {
      return '';
    }
    return addressFormat(this.alpaca.shepherd);
  }

  get hatchedBy() {
    if (!this.alpaca) {
      return '';
    }
    return addressFormat(this.alpaca.hatched_by);
  }

  get birthday() {
    if (this.alpaca) {
      return format(new Date(this.alpaca.birthday), 'MM/dd/yyyy');
    }
    return 'N/A';
  }

  get dateOfDeath() {
    if (this.alpaca) {
      return format(new Date(this.alpaca.recycled_at), 'MM/dd/yyyy');
    }
    return 'N/A';
  }

  get hasChild() {
    return this.alpaca && this.alpaca.children;
  }

  get hasWearable() {
    return this.alpaca && this.alpaca.wearables;
  }

  get isEgg() {
    return this.alpaca && this.alpaca.state === 0 && !this.isRecycled;
  }

  get canBoost() {
    return Number(this.alpacaID) <= 100 && this.account && this.alpaca;
  }

  get breedBase() {
    if (!this.alpaInfoFromContract) {
      return '-';
    }
    return alpaUnit(this.alpaInfoFromContract.hatchingCost);
  }

  get breedMultiplier() {
    if (!this.alpaInfoFromContract) {
      return '-';
    }
    return Number(this.alpaInfoFromContract.hatchingCostMultiplier);
  }

  get canBeBreed() {
    return this.alpaca && this.alpaca.is_owner;
  }

  get canWear() {
    return this.alpaca && this.alpaca.is_owner;
  }

  public async created() {
    this.getAlpacaInfo();
  }

  public mounted() {
    EventBus.$on('approve-status', this.onApproveStatus);
  }

  public beforeDestroy() {
    EventBus.$off('approve-status', this.onApproveStatus);
  }

  public async onApproveStatus(status: 'approving' | 'completed' | 'error') {
    if (status === 'completed') {
      this.getIsApprovedForAll();
      this.approveLoading = false;
    }
    if (status === 'error') {
      this.approveLoading = false;
    }
  }

  public async getAlpacaInfo() {
    const res = await getAlpacaInfo(this.alpacaID, this.account);
    if (res) {
      this.alpaca = res.data;
    }
    this.loaded = true;
  }

  public async getIsOwner() {
    this.isOwner = await isOwnerOf(this.account, this.alpacaID);
  }

  public async getAlpacaInfoFromContract() {
    const info = await getAlpaca(Number(this.alpacaID));
    if (info) {
      this.alpaInfoFromContract = info;
      this.calcRemainingTime();
      this.calcCostRestRemainingTime();
    }
  }

  public async getIsApprovedForAll() {
    const res = await isApprovedForAll(process.env.VUE_APP_ALPACA_TAILOR_CONTRACT_ADDRESS!, this.account);
    if (res) {
      this.isApprovedForWear = res;
    }
  }

  public goTransfer() {
    if (!this.alpaca) {
      return;
    }
    EventBus.$emit('item-transfer',
    {id: this.alpaca.id, svg_url: this.alpaca.svg_url,
    state: this.alpaca.state, bgColor: this.alpaca.card_background_color}, 'alpaca');
  }

  // public async getCurBlockNumber() {
  //   this.curBlockNumber = await getCurBlockNumber();
  // }

  public goBreed() {
    this.$router.push({ name: ROUTE_BREEDING, params: {selectedAlpaca: JSON.stringify(this.alpaca)} });
  }

  public handleCrack() {
    if (!this.alpaca) {
      return;
    }
    crack(this.account, this.alpaca.id);
  }

  public goEtherscan(address: string) {
    if (!this.alpaca) {
      return;
    }
    window.open(process.env.VUE_APP_NET + 'address/' + address);
  }

  public async calcRemainingTime() {
    if (!this.alpaInfoFromContract) {
      return;
    }
    const curBlockNumber = await getCurBlockNumber();
    this.countdown = (this.alpaInfoFromContract.cooldownEndBlock - curBlockNumber) * secPerBlock * 1000;
    if (this.countdown < 0) {
      this.countdown = 0;
    }
    this.remainingTime = this.countdown;
  }

  public async calcCostRestRemainingTime() {
    if (!this.alpaInfoFromContract) {
      return;
    }
    const curBlockNumber = await getCurBlockNumber();
    this.costResetCountdown =
      (this.alpaInfoFromContract.hatchCostMultiplierEndBlock - curBlockNumber) * secPerBlock * 1000;
    if (this.costResetCountdown < 0) {
      this.costResetCountdown = 0;
    }
    this.costResetRemainingTime = this.countdown;
  }

  public handleCountdownProgress(data: any) {
    this.remainingTime = data.totalSeconds;
    if (this.remainingTime === 1) {
      setTimeout(() => {
        this.remainingTime = 0;
      }, 1000);
    }
  }

  public handleCostResetCountdownProgress(data: any) {
    this.costResetRemainingTime = data.totalSeconds;
    if (this.remainingTime === 1) {
      setTimeout(() => {
        this.remainingTime = 0;
      }, 1000);
    }
  }

  public handleApprove() {
    this.approveLoading = true;
    setApprovalForAll(process.env.VUE_APP_ALPACA_TAILOR_CONTRACT_ADDRESS!, this.account);
  }

  public clickWearableCard(wearable: Wearable) {
    if (!this.alpaca) {
      return;
    }
    wear(Number(wearable.id), this.alpacaID, this.alpaca.shepherd, this.account);
  }

  public hanleTakeOff(wearable: Wearable) {
    if (!this.alpaca) {
      return;
    }
    takeOff(1, this.alpacaID, this.alpaca.shepherd, this.account);
  }

  @Watch('account', {immediate: true})
  public onAccount(val: string) {
    if (val) {
      this.getIsOwner();
      this.getAlpacaInfo();
      this.getIsApprovedForAll();
      this.getAlpacaInfoFromContract();
    }
  }

  @Watch('alpacaID', {immediate: true})
  public onAlpacaID(val: string) {
    if (val) {
      this.loaded = false;
      this.getIsOwner();
      this.getAlpacaInfo();
      this.getIsApprovedForAll();
      this.getAlpacaInfoFromContract();
    }
  }
}
